import { createStorage } from "unstorage";
import localStorageDriver from "unstorage/drivers/localstorage";
function setupVoixUserXP(voix) {
  if (import.meta.client) {
    voix.eventBus.on("voix:page:viewed", (page) => {
      if (page.tags) {
        for (const tag of page.tags) {
          const experience = `tag:${tag.name}`;
          addVoixUserXP(experience, (currentValue = 0) => {
            return currentValue + Number.parseInt(tag.point);
          }).then((value) => {
            voix.eventBus.emit("voix:userXP:added", { experience, value });
          }).catch(() => {
          });
        }
      }
    });
    voix.eventBus.on("voix:slice:viewed", (slice) => {
      if (slice.tags) {
        for (const tag of slice.tags) {
          const experience = `tag:${tag.name}`;
          addVoixUserXP(experience, (currentValue = 0) => {
            return currentValue + Number.parseInt(tag.point);
          }).then((value) => {
            voix.eventBus.emit("voix:userXP:added", { experience, value });
          }).catch(() => {
          });
        }
      }
    });
  }
}
async function addVoixUserXP(experience, callback) {
  const storage = createStorage({
    driver: localStorageDriver({ base: "voix:" })
  });
  const currentValue = await storage.getItem(experience);
  const newValue = callback(currentValue);
  await storage.setItem(experience, newValue);
  return newValue;
}
async function getVoixUserXP() {
  const storage = createStorage({
    driver: localStorageDriver({ base: "voix:" })
  });
  const userXP = {};
  const allKeys = await storage.getKeys("voix:");
  for (const key of allKeys) {
    const keyWithoutPrefix = key.replace("voix:", "");
    const tagName = keyWithoutPrefix.replace("tag:", "");
    userXP[tagName] = await storage.getItem(keyWithoutPrefix);
  }
  return userXP;
}
export {
  addVoixUserXP,
  getVoixUserXP,
  setupVoixUserXP
};
